// extracted by mini-css-extract-plugin
export default {"BomContentHeader":"productHeader-module_BomContentHeader_cy4ul","ProductTitle":"productHeader-module_ProductTitle_myOEY","Icon":"productHeader-module_Icon_vlsel"};